import { Box, IconButton, Typography } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";

export const CustomIconButton = ({ icon, onClick, sx, size = "medium", ...rest }) => {
  return (
    <IconButton onClick={onClick} sx={{ ...sx }} size={size} {...rest}>
      {icon}
    </IconButton>
  );
};


export const FloatingButton = ({ icon, onClick, position, bgcolor, sx, size = "medium" }) => {
  return (
    <IconButton
      sx={{
        position: "absolute",
        ...position,
        backgroundColor: bgcolor,
        "&:hover": { backgroundColor: bgcolor },
        ...sx
      }}
      onClick={onClick}
      size={size}
    >
      {icon}
    </IconButton>
  );
};

export const CircleIconButton = ({ icon, onClick, bgcolor, position, border }) => {
  return (
    <IconButton
      sx={{
        bgcolor: bgcolor,
        borderRadius: "50%",
        p: "10px",
        position: position || "absolute",
        ...position,
        border: border,
        "&:hover": {
          bgcolor: bgcolor,
        },
      }}
      onClick={onClick}
    >
      {icon}
    </IconButton>
  );
};


export const NavigationButton = ({ icon, onClick, edge, size = "small" }) => {
  return (
    <IconButton edge={edge} onClick={onClick} size={size}>
      {icon}
    </IconButton>
  );
};

export const CircularButton = ({ onClick, icon }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{

        boxShadow: "0px 4px 4px 0px #4169E11A",
        borderRadius: "50%",
        padding: "6px",
        display: "grid",
        placeItems: "center",
        bgcolor: "main.light",


      }}

    >

      <Icon icon={icon} color="#141C36" width="24" height="24" />
    </IconButton>
  )
};

export const FilterButton = ({ onClick, bgcolor, border }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        borderRadius: "12px",
        px: 2,
        display: "grid",
        placeItems: "center",
        border: border || "none",
        bgcolor: bgcolor || "#F7F7F7",


      }}

    >

      <Icon icon="mynaui:filter-solid" color="#000" width="24" height="24" />
    </IconButton>
  )
};

 export const StatusButton = ({ status }) => {
  return (
    <Box border={status == 1 ? "1px solid #4CAF50" : "1px solid #FF0000"} bgcolor={status == 1 ? "#E8F5E9" : "#FFEBEE"} borderRadius={2} display={"flex"} alignItems={"center"} gap={1} px={2} py={0.5}>
      {/* <Icon icon={item?.status===1?"mynaui:check-circle-solid":"mynaui:cross-circle-solid"} color={item?.status===1?"#4CAF50":"#FF0000"} width="16" height="16" /> */}
      <Typography color={status == 1 ? "#4CAF50" : " #FF0000"}>{status == 1 ? "Active" : "In Active"}</Typography>
    </Box>
  );
}